import { render, staticRenderFns } from "./popularizeLaw.vue?vue&type=template&id=723b9efb&scoped=true&"
var script = {}
import style0 from "./popularizeLaw.vue?vue&type=style&index=0&id=723b9efb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723b9efb",
  null
  
)

export default component.exports